import { LCObTokens } from '../LC/LC.obTokens';

export const FEObTokens = {
  ...LCObTokens,
};
